import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchKnowledgeEntries,
  fetchKnowledgeDetail,
  publishKnowledge,
  archiveKnowledge,
} from '@/services/api/knowledge'
import type { KnowledgeStatus } from '@/types/knowledge'

export function useKnowledgeList(params: {
  page?: number
  page_size?: number
  keyword?: string
  status?: KnowledgeStatus
}) {
  return useQuery({
    queryKey: ['knowledge', 'list', params],
    queryFn: () => fetchKnowledgeEntries(params),
    staleTime: 30_000,
  })
}

export function useKnowledgeDetail(entryId: number | null) {
  return useQuery({
    queryKey: ['knowledge', 'detail', entryId],
    queryFn: () => fetchKnowledgeDetail(entryId!),
    enabled: !!entryId,
  })
}

export function usePublishKnowledge() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ entryId, reviewer }: { entryId: number; reviewer?: string }) =>
      publishKnowledge(entryId, reviewer),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['knowledge'] })
    },
  })
}

export function useArchiveKnowledge() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ entryId }: { entryId: number }) =>
      archiveKnowledge(entryId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['knowledge'] })
    },
  })
}
